import React, { useEffect, useState } from 'react';
import { AnemometersType } from '../../apis/Anemometers.api';

interface props {
  anemometer: AnemometersType | undefined;
  elRef: React.RefObject<SVGTextElement>;
  setAnemoX: React.Dispatch<React.SetStateAction<number>>;
  setAnemoY: React.Dispatch<React.SetStateAction<number>>;
}

export const Anemometer: React.FC<props> = (props) => {
  const data = props.anemometer;
  const gElRef = props.elRef;
  const setAnemoX = props.setAnemoX;
  const setAnemoY = props.setAnemoY;

  const [curElementWidth, setCurElementWidth] = useState<number>();
  const GetColor = (status: boolean | undefined) => {
    return status === true ? 'red' : 'white';
  };

  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      if (gElRef.current) {
        setAnemoX(gElRef.current.getBoundingClientRect().x);
        setAnemoY(gElRef.current.getBoundingClientRect().y);
        setCurElementWidth(gElRef.current.clientWidth);
      }
    }
    return () => {
      unmounted = true;
    };
  }, [gElRef, setAnemoX, setAnemoY]);

  return (
    <>
      {data ? (
        <g fill='white'>
          <text y={650} ref={gElRef}>
            <tspan fontSize='38'>平均：</tspan>
            <tspan
              fontSize='80'
              fontWeight='bold'
              fill={GetColor(data?.average_red)}
            >{`${data?.average}`}</tspan>

            <tspan fontSize='38'> m/s</tspan>
            <tspan fontSize='38'> </tspan>
            <tspan fontSize='38'>最大：</tspan>
            <tspan
              fontSize='90'
              fontWeight='bold'
              fill={GetColor(data?.max_red)}
            >{`${data?.max}`}</tspan>
            <tspan fontSize='40'> m/s</tspan>
          </text>
          <text
            fontSize='30'
            y={690}
            dx={curElementWidth}
            textAnchor='end'
          >{`(${data?.time})`}</text>
        </g>
      ) : null}
    </>
  );
};
